/**
 * Parte la lista de notificaciones en leídas/no-leídas según el shape nuevo
 * del backend (`leida: boolean`) y aplica el filtro del tab activo.
 *
 * @param {Array} arr - lista cruda del back
 * @param {"Todos"|"Sin leer"|"Leídos"} [filtro="Todos"]
 * @returns {{ noleidos: Array, leidos: Array }}
 */
export const filterNotification = (arr, filtro = "Todos") => {
  const list = Array.isArray(arr) ? arr : [];
  const noleidos = list.filter((n) => !n.leida);
  const leidos = list.filter((n) => n.leida);

  if (filtro === "Sin leer") return { noleidos, leidos: [] };
  if (filtro === "Leídos") return { noleidos: [], leidos };
  return { noleidos, leidos };
};
